const config = {
  gatsby: {
    pathPrefix: '/',
    siteUrl: 'https://hasura.io',
    gaTrackingId: null,
    trailingSlash: false,
  },
  header: {
    // logo: 'https://graphql-engine-cdn.hasura.io/learn-hasura/assets/homepage/brand.svg',
    // logoLink: 'https://hasura.io/learn/',
    // title:
    //   "<a href='https://hasura.io/learn/'><img class='img-responsive' src='https://graphql-engine-cdn.hasura.io/learn-hasura/assets/homepage/learn-logo.svg' alt='Learn logo' /></a>",
    githubUrl: 'https://github.com/screencloud/apps/tree/master/sites/alfie-documentation',
    helpUrl: 'https://github.com/screencloud/apps/issues',
    // tweetText: '',
    // social: `<li>
    //     <a href="https://twitter.com/hasurahq" target="_blank" rel="noopener">
    //       <div class="twitterBtn">
    //         <img src='https://graphql-engine-cdn.hasura.io/learn-hasura/assets/homepage/twitter-brands-block.svg' alt={'Discord'}/>
    //       </div>
    //     </a>
    //   </li>
    // 	<li>
    //     <a href="https://discordapp.com/invite/hasura" target="_blank" rel="noopener">
    //       <div class="discordBtn">
    //         <img src='https://graphql-engine-cdn.hasura.io/learn-hasura/assets/homepage/discord-brands-block.svg' alt={'Discord'}/>
    //       </div>
    //     </a>
    //   </li>`,
    links: [{ text: '', link: '' }],
    search: {
      enabled: false,
      indexName: '',
      algoliaAppId: process.env.GATSBY_ALGOLIA_APP_ID,
      algoliaSearchKey: process.env.GATSBY_ALGOLIA_SEARCH_KEY,
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY,
    },
  },
  sidebar: {
    forcedNavOrder: [
      '/introduction', // add trailing slash if enabled above
      '/concepts',
      '/core',
      '/components',
      '/icon-logo',
      '/animation',
      '/resources',
    ],
    collapsedNav: [
      '/introduction', // add trailing slash if enabled above
      '/concepts',
      '/core',
      '/components',
      '/icon-logo',
      '/animation',
      '/resources',
    ],
    links: [{ text: 'ScreenCloud', link: 'https://screen.cloud/' }],
    frontline: false,
    ignoreIndex: true,
    title:
      "<img class='sidebar-logo' src='https://sc-apps-static-assets-staging.s3-eu-west-1.amazonaws.com/alfie/screencloud_logo.png'>",
  },
  siteMetadata: {
    title: 'Alfie documentation site | ScreenCloud',
    description: 'Design documentation for developing apps',
    ogImage: null,
    docsLocation:
      'https://github.com/screencloud/apps/tree/master/sites/alfie-documentation/content',
    favicon: 'https://screen.cloud/static/img/favicon.png',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'ScreenCloud UI Library',
      short_name: 'ScreenCloudUILibrary',
      start_url: '/',
      background_color: '#6b37bf',
      theme_color: '#6b37bf',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
